
// 인자: 전시소재번호 → return component명
export const getExhMtrlTyCd = (cd, exhCnrId) => {
  switch (cd) {
    case '01':
      return 'banner'
    case '02':
      return 'product'
    case '03':
      return 'texts'
    case '04':
      return 'movies'
    case '05':
      return 'buttons'
    case '06':
      return 'categoryProduct'
    case '07':
      return 'html'
    case '08':
      return 'link'
    case '09':
      return 'bundleProducts'
    case '10':
      return 'newProducts'
    case '11':
      return 'contents' // 컨텐츠형: 수정 필요 - 레디스에서 사용할 명칭 아직 모름
    case '12':
      if (exhCnrId === 'C101') {
        return 'exbt'
      } else {
        return 'etcExbt'
      }
    case '13':
      return 'productReview'
    case '14':
      return 'htmlProduct'
    case '17':
      return 'timer'
    default:
      return ''
  }
}

export const setExhMtrlApi = (cd) => {
  switch (cd) {
    case 'banner':
      return '/ds/exh/selBanr'
    case 'product':
      return '/ds/exh/selProduct'
    case 'texts':
      return '/ds/exh/selText'
    case 'movies':
      return '/ds/exh/selMovie'
    case 'buttons':
      return '/ds/exh/selButton'
    case 'categoryProduct':
      return '/ds/exh/selCategory'
    case 'html':
      return '/ds/exh/selHtml'
    case 'link':
      return '/ds/exh/selLink'
    case 'bundleProducts':
      return '/ds/exh/selBundle'
    case 'newProducts':
      return '/ds/exh/selNewProduct'
    case 'contents':
      // return '/ug/ugm/selMainHofCtenList' // 컨텐츠형: 수정 필요 - 레디스에서 사용할 명칭 아직 모름
      return '/ds/exh/selContent' // 컨텐츠형: 수정 필요 - 레디스에서 사용할 명칭 아직 모름
    case 'exbt':
      return '/ds/exh/selExbt'
    case 'etcExbt':
      return '/ds/exh/selExbt'
    case 'productReview':
      return '/ds/exh/selReview'
    case 'htmlProduct':
      return '/ds/exh/selHtmlProduct'
    case 'timer':
      return '/ds/exh/selTimer'
    default:
      return ''
  }
}

/**
 * 코너의 구좌 조회
 * @param {id, $api} 코너 ID
 * @returns 구좌 List
 */
export const getAccntList = (id, $api) => {
  const params = {
    exhCnrId: id
  }

  const accountList = $api.post('/ds/exh/selExh', params).then((res) => {
    if (res.data.success) {
      return res.data.data.filter((item) => { return item.aplMdiaPcomYn === 'Y' })
    }
  })

  return accountList
}

/**
 * 기획전에 연결된 각 구좌의 소재 조회
 * @param {accountList, $api} 구좌 List
 * @returns 소재 List
 */
export async function getExbtMtrlsList (exbtList, $api) {
  const updatedExbtList = await Promise.all(
    exbtList.map(async (e) => {
      try {
        await Promise.all(
          e.mtrls.map(async (obj) => {
            const resultList = []
            // return: 소재별 component명
            const typeCd = getExhMtrlTyCd(obj.exhMtrlTyCd)
            // return: 소재별 api
            const url = setExhMtrlApi(typeCd)

            let params = {
              exhCmptmtId: obj.exhCmptmtId,
              exhMtrlNo: obj.exhMtrlNo,
            }

            // 상품 소재: mo(20), pc(10) 구분 필요
            if (typeCd === 'product') {
              params = {
                ...params,
                deviceTypeCd: 10
              }
            }

            // return 값 resultList에 push
            resultList.push(
              await $api.post(url, params).then((res) => {
                if (res.data.success) {
                  return res.data.data
                }
              })
            )

            // obj에 exhCmptmtMtrlDtl 필드로 추가
            obj.exhCmptmtMtrlDtl = resultList
          })
        )
      } catch (e) {
        console.log('e', e)
      }
      return e
    })
  )
  console.log(updatedExbtList)
  return updatedExbtList
}
